import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import { Observable } from 'rxjs';
import { RouterStateTrackerService } from 'src/app/services/router-state-tracker.service';

type SlidePosition = '/calendar' | '/menu' | '/order' | '/notifications' | '/accounts' | any;

@Component({
  selector: 'app-slide-bar',
  templateUrl: './slide-bar.component.html',
  styleUrls: ['./slide-bar.component.scss'],
  standalone:false
})
export class SlideBarComponent implements AfterViewInit {
  @ViewChild('container') container!: ElementRef<HTMLDivElement>;
  @ViewChild('handle') handle!: ElementRef<HTMLDivElement>;

  @Output() positionChange = new EventEmitter<{ current: SlidePosition | any; previous: SlidePosition | any }>();

  snapPositions: number[] = [0, 0.5, 1]; // normalized 0-1 positions
  offPosition: SlidePosition = '/accounts'; // “off” state
  @Input() currentActiveRoute: any;
  @Input() showOrders: boolean = true;
  canSlide: boolean = true;

tabs = [
      { route: '/calendar', iconSvgPath: '/assets/svg/calendar.svg', id: 'nav-1' },
      { route: '/menu', iconSvgPath: '/assets/svg/menu-n.svg', id: 'nav-2' },
      this.showOrders
        ? { route: '/order', iconSvgPath: '/assets/svg/carts.svg', id: 'nav-3' }
        : { route: '/notifications', iconSvgPath: '/assets/svg/nbell.svg', id: 'nav-3' },
        { route: '/accounts', iconSvgPath: '/assets/svg/user.svg', id: 'nav-4' },
    ];
      scaleX = 1;
  scaleY = 1 ;
  rotation = 0;
  skewY = 1 ;
  skewX = 1 ;
  private containerWidth = 0;
  private handleWidth = 0;

  private dragging = false;
  private lastX = 0;

  private handleLeft = 0; // current left px
  private targetLeft = 0 ; // target left px
  private velocity = 0;

  private currentPosition: SlidePosition | any = '';
  private previousPosition: SlidePosition | any = '';
  private targetPosition: SlidePosition | any = '';

  private animationFrame!: any;
private liveActivePosition: SlidePosition | any = '';
    isNavigating$: Observable<boolean>;
readonly SPRING_STRENGTH = 0.025;
readonly DAMPING_FACTOR = 0.85; // Slightly increased damping for smoother stops
readonly REST_VELOCITY_THRESHOLD = 0; // Velocity threshold to consider the handle "at rest"
readonly MAX_JIGGLE_SCALEX = 1.2; // Maximum scale when moving quickly
readonly MIN_JIGGLE_SCALEX = 0.9; // Minimum scale when moving quickly
readonly MAX_JIGGLE_SCALE = 1.4; // Maximum scale when moving quickly
readonly MIN_JIGGLE_SCALE = 0.7; // Minimum scale when moving quickly
readonly BASE_WOBBLE_FACTOR = 0.05; // Very small, constant movement (at rest)
readonly MOVEMENT_WOBBLE_FACTOR = 0.5; // Amplitude boost when velocity is high
  previousNearestIndex: number;
// -------------------------------------------------------------------


constructor(
  private routerStateTracker: RouterStateTrackerService
){
  
   this.routerStateTracker.isNavigating$.subscribe(val => {
      this.canSlide = !val;
      console.log(this.canSlide, "can it slide")
    });
}

  ngAfterViewInit() {
    // this.containerWidth = this.convertToPixels("80vw")
    // this.handleWidth = this.convertToPixels("24vw")
    this.containerWidth = this.container.nativeElement.offsetWidth;
    this.handleWidth = this.handle.nativeElement.offsetWidth;
       
          this.liveActivePosition = this.currentActiveRoute;
      this.currentPosition = this.currentActiveRoute;
     this.previousPosition = this.currentActiveRoute;

    if (this.currentActiveRoute === '/calendar'){
      this.handleLeft = this.convertToPixels("0vw");
    } else if (this.currentActiveRoute === '/menu'){
this.handleLeft = this.convertToPixels("24vw");
    } else if (this.currentActiveRoute === '/order'){
this.handleLeft = this.convertToPixels("48vw");
    } else {
      const handleEl = this.handle.nativeElement;
          handleEl.style.opacity = '0';
    handleEl.style.pointerEvents = 'none';
    }
    // Initial position
    // this.handleLeft = this.snapPositions[1] * (this.containerWidth - this.handleWidth);
    this.targetLeft = this.handleLeft;

    // Attach events
    this.handle.nativeElement.addEventListener('mousedown', this.startDrag.bind(this));
    this.handle.nativeElement.addEventListener('touchstart', this.startDrag.bind(this), { passive: false });
    document.addEventListener('mousemove', this.onDrag.bind(this));
    document.addEventListener('touchmove', this.onDrag.bind(this), { passive: false });
    document.addEventListener('mouseup', this.stopDrag.bind(this));
    document.addEventListener('touchend', this.stopDrag.bind(this));
    this.container.nativeElement.addEventListener('click', this.jumpToPosition.bind(this));

    // Start animation
 
    this.animate();
  // const jiggler = handleEl.querySelector('.jiggler') as HTMLElement;
  // handleEl.style.left = `${this.handleLeft}px`;

    //  console.log(this.currentPosition, "current")
    //   console.log(this.liveActivePosition, "live")
    //   console.log(this.currentActiveRoute, "route")
    //   this.liveActivePosition = this.currentActiveRoute;
    //   this.currentPosition = this.currentActiveRoute;
    //   console.log(this.currentPosition, "current")
    //   console.log(this.liveActivePosition, "live")
    //   console.log(this.currentActiveRoute, "route")
    // this.snapToNearest()
  }

canClick(route: string) {
  // let activePosition: SlidePosition | number;

  // If handle is in off position
  if (this.currentPosition === route) {
    return "noClick"
  } else {
    return "canClick"
  }
}
iconColors(route: string) {
  if (this.currentPosition === '/accounts' && route !== '/accounts'){
    return 'unSelectedIcon'
  }
  return route === this.liveActivePosition ? 'selectedIcon' : 'unSelectedIcon';
}

jiggleClass(){
  switch (this.liveActivePosition) {
        case '/calendar':
          return 'calendarCut';
        case '/menu':
          return 'menuCut';
        case '/order':
          return 'orderCut';
        case '/accounts':
          return '';
        case '/notifications':
          return 'orderCut';
        default:
          return '';
      }
}
 
  convertToPixels(v: string) {
    const value = parseFloat(v);
    if (v.endsWith('vh')) return (value / 100) * innerHeight;
    if (v.endsWith('vw')) return (value / 100) * innerWidth;
    return value;
  }

// private animate() {
//   const handleEl = this.handle.nativeElement;
//   const jiggler = handleEl.querySelector('.jiggler') as HTMLElement;

//   // --- 1. Sanity Check and Setup ---
//   if (!handleEl || !jiggler || this.containerWidth <= 0 || this.handleWidth <= 0) {
//     this.animationFrame = requestAnimationFrame(() => this.animate());
//     return;
//   }

//   const maxLeft = this.containerWidth - this.handleWidth;
//   const isOffPosition = this.currentPosition === this.offPosition;
//   const isMoving = Math.abs(this.velocity) > this.REST_VELOCITY_THRESHOLD;

//   // --- 2. Handle Off State (Optimized Visibility) ---
//   if (isOffPosition) {
//     // Use opacity/pointer-events for clean visibility toggle
//     handleEl.style.opacity = '0';
//     handleEl.style.pointerEvents = 'none';
//     // jiggler.style.transform = `scale(1)`;
//     this.animationFrame = requestAnimationFrame(() => this.animate());
//     return;
//   }

//   // Ensure handle is active
//   handleEl.style.opacity = '1';
//   handleEl.style.pointerEvents = 'auto';

//   // --- 3. Physics Update (Position & Velocity) ---
//   const diff = this.targetLeft - this.handleLeft;
  
//   // Calculate new velocity (Damping + Spring force)
//   this.velocity = this.velocity * this.DAMPING_FACTOR + diff * this.SPRING_STRENGTH;
//   this.handleLeft += this.velocity;

//   // Clamp position to stay within slider bounds
//   this.handleLeft = Math.max(0, Math.min(this.handleLeft, maxLeft));
  
//   // Apply position update
//   handleEl.style.left = `${this.handleLeft}px`;

//   // --- 4. Visual Update (Jiggle/Wobble/Scale) ---
//   const time = Date.now() * 0.001;
//   let scaleX = 1;
//   let scaleY = 1;
//   let rotation = 0;
//   let skewY = 0;
//   let skewX = 0;
//   // Base subtle motion (Barely visible at rest)
//   scaleX += Math.sin(time * 3) * this.BASE_WOBBLE_FACTOR;
//   rotation += Math.cos(time * 5) * (this.BASE_WOBBLE_FACTOR / 2);
  
//   // Apparent motion (When moving)
//   if (isMoving) {
//     // Intensity is proportional to velocity magnitude
//     const movementIntensity = Math.min(Math.abs(this.velocity) * this.MOVEMENT_WOBBLE_FACTOR, 0.4); 
    
//     // Squash & Stretch: Squish vertically, stretch horizontally, proportional to speed
//     scaleX += movementIntensity * 0.7; 
//     scaleY += movementIntensity * 1.1;
//     skewY += Math.min(Math.abs(this.velocity)*1.5, 0.4);
//     skewX += Math.min(Math.abs(this.velocity)*1.4, 0.4);

//     // Add a more intense, faster rotational jiggle
//     rotation += Math.sin(time * 12) * movementIntensity; 
//   }
  
//   // Clamp scale values to prevent aggressive distortion
//   scaleX = Math.min(this.MAX_JIGGLE_SCALE, Math.max(this.MIN_JIGGLE_SCALE, scaleX));
//   scaleY = Math.min(this.MAX_JIGGLE_SCALE, Math.max(this.MIN_JIGGLE_SCALE, scaleX));
//   // console.log(scaleX, scaleY, skewX, skewY, rotation ,this.liveActivePosition,this.handleLeft, "animation")
//   // Apply visual transformation
//   jiggler.style.transform = `scaleX(${scaleX}) scaleY(${scaleY}) skewY(${skewY}deg) skewX(${skewX}deg)`;
//   jiggler.style.transition = `all 0.6s ease`;

//   // --- 5. Snap Position Tracking ---
//   const normalizedLeft = this.handleLeft / maxLeft;

//   // Simplified logic to find the nearest snap index
//   const nearestIndex = this.snapPositions.reduce((bestIndex, currentSnap, currentIndex) => {
//       const distCurrent = Math.abs(currentSnap - normalizedLeft);
//       const distBest = Math.abs(this.snapPositions[bestIndex] - normalizedLeft);
//       return distCurrent < distBest ? currentIndex : bestIndex;
//   }, 0);

//   this.liveActivePosition = this.indexToPosition(nearestIndex);

//   // Continue the animation loop
//   this.animationFrame = requestAnimationFrame(() => this.animate());
// }

private animate() {
  const handleEl = this.handle.nativeElement;
  const jiggler = handleEl.querySelector('.jiggler') as HTMLElement;

  // --- 1. Sanity Check and Setup ---
  if (!handleEl || !jiggler || this.containerWidth <= 0 || this.handleWidth <= 0) {
    this.animationFrame = requestAnimationFrame(() => this.animate());
    return;
  }

  const maxLeft = this.containerWidth - this.handleWidth;
  const isOffPosition = this.currentPosition === this.offPosition;
  const isMoving = Math.abs(this.velocity) > this.REST_VELOCITY_THRESHOLD;

  // --- 2. Handle Off State (Optimized Visibility) ---
  if (isOffPosition) {
    handleEl.style.opacity = '0';
    handleEl.style.pointerEvents = 'none';
    this.animationFrame = requestAnimationFrame(() => this.animate());
    return;
  }

  // Ensure handle is active
  handleEl.style.opacity = '1';
  handleEl.style.pointerEvents = 'auto';

  // --- 3. Physics Update (Position & Velocity) ---
  const diff = this.targetLeft - this.handleLeft;
  
  // Calculate new velocity (Damping + Spring force)
  this.velocity = this.velocity * this.DAMPING_FACTOR + (diff/1.15) * this.SPRING_STRENGTH;
  this.handleLeft += this.velocity;

  // Clamp position to stay within slider bounds
  this.handleLeft = Math.max(1, Math.min(this.handleLeft, maxLeft-1));
  
  // Apply position update
  handleEl.style.left = `${this.handleLeft}px`;

  // --- 4. Visual Update (Jiggle/Wobble/Scale) ---
  const time = Date.now() * 0.05;
  let scaleX = 1;
  let scaleY = 1;
  let rotation = this.rotation;
  let skewY = this.skewX;
  let skewX = this.skewY;

  // 4.A Snap Position Tracking (Moved up to determine direction BEFORE animation)
  const normalizedLeft = this.handleLeft / maxLeft;

  const nearestIndex = this.snapPositions.reduce((bestIndex, currentSnap, currentIndex) => {
      const distCurrent = Math.abs(currentSnap - normalizedLeft);
      const distBest = Math.abs(this.snapPositions[bestIndex] - normalizedLeft);
      return distCurrent < distBest ? currentIndex : bestIndex;
  }, 0);

  // --- 4.B Directional Animation Calculation (NEW BLOCK) ---
  const indexDelta = nearestIndex - this.previousNearestIndex; // -3 to 3
  const isDirectionalMove = Math.abs(indexDelta) > 0 && isMoving;
  
  // Normalized velocity for intensity (Clamped between 0 and 1)
  const movementIntensity = Math.min(Math.abs(this.velocity) * this.MOVEMENT_WOBBLE_FACTOR, 1); 

  // Base subtle motion (Barely visible at rest)
  const subtleOscillation = Math.cos(time) * 5;

  // scaleX += subtleOscillation > 0 ? Math.sin(time*2) * this.BASE_WOBBLE_FACTOR : Math.sin(time*2) * this.BASE_WOBBLE_FACTOR;
  // // scaleY += Math.cos(time*12) * this.BASE_WOBBLE_FACTOR;
  // scaleY += subtleOscillation > 0 ? Math.cos(time*2) * this.BASE_WOBBLE_FACTOR : Math.cos(time*2) * this.BASE_WOBBLE_FACTOR;
  //   skewX += subtleOscillation > 0 ? Math.sin(time*2) * this.BASE_WOBBLE_FACTOR : Math.sin(time*2) * this.BASE_WOBBLE_FACTOR;
  // // scaleY += Math.cos(time*12) * this.BASE_WOBBLE_FACTOR;
  // skewY += subtleOscillation > 0 ? Math.cos(time*2) * this.BASE_WOBBLE_FACTOR : Math.cos(time*2) * this.BASE_WOBBLE_FACTOR;
  // rotation += subtleOscillation;
  //   skewX += Math.sin(time*20) * this.BASE_WOBBLE_FACTOR;
  // skewY += Math.cos(time*10) * this.BASE_WOBBLE_FACTOR;
  // if (!isDirectionalMove){
  // scaleX = Math.min(1.025, Math.max(0.975, scaleX));
  // scaleY = Math.min(1.05, Math.max(0.95, scaleY));
  // skewX = Math.min(0, Math.max(0, skewX));
  // skewY = Math.min(0, Math.max(0, skewY));
  // }
  if (isDirectionalMove) {
    // Determine the direction of the index change
    const isMovingRight = indexDelta > 0;
    const isMovingLeft = indexDelta < 0;

    // --- Direction-Aware Effects ---
    
    // Squish & Stretch (Stronger effect proportional to movement speed)
    // scaleX += movementIntensity * 0.15; // General stretch boost while moving
    // scaleY -= movementIntensity * 0.10; // Compensatory squish

    // Skew X (Lean): The crucial directional effect
  //   if (isMovingRight) {
  // scaleX += subtleOscillation > 0 ? Math.sin(time*20) : Math.sin(time*20);
  // // scaleY += Math.cos(time*12);
  // scaleY += subtleOscillation > 0 ? Math.cos(time*20) : Math.cos(time*20);
  //   skewX += subtleOscillation > 0 ? Math.sin(time*20) : Math.sin(time*20);
  // // scaleY += Math.cos(time*12);
  // skewY += subtleOscillation > 0 ? Math.cos(time*20) : Math.cos(time*20);
  //   } else if (isMovingLeft) {
  // scaleX += subtleOscillation > 0 ? Math.sin(time*20) : Math.sin(time*20);
  // // scaleY += Math.cos(time*12);
  // scaleY += subtleOscillation > 0 ? Math.cos(time*20) : Math.cos(time*20);
  //   skewX += subtleOscillation > 0 ? Math.sin(time*20) : Math.sin(time*20);
  // // scaleY += Math.cos(time*12);
  // skewY += subtleOscillation > 0 ? Math.cos(time*20) : Math.cos(time*20);
  //   }
    
    // Skew Y (Shear): Remains generic, proportional to speed
    // skewY += movementIntensity * 5; 

    // Rotation: Faster jiggle during movement
     
  }
  
  // Clamp scale values to prevent aggressive distortion
  // scaleX = Math.min(this.MAX_JIGGLE_SCALEX, Math.max(this.MIN_JIGGLE_SCALEX, scaleX));
  // scaleY = Math.min(this.MAX_JIGGLE_SCALE, Math.max(this.MIN_JIGGLE_SCALE, scaleY));
  // rotation = Math.min(1, Math.max(0.5, rotation));

    // this.skewX = Math.min(10, Math.max(-10, this.skewX));
  // this.skewY = Math.min(10, Math.max(-10, this.skewY));
  
  // Apply visual transformation
  // jiggler.style.transform = `scaleX(${scaleX}) scaleY(${scaleY})`;
  // jiggler.style.borderRadius = `${skewX + 5}`;
  // jiggler.style.opacity = `${rotation}`;
  jiggler.style.transition = `all 0s ease`;
  // this.scaleX = scaleX;
  // this.scaleY = scaleY;
  // this.rotation = rotation;
  // this.skewY = skewX;
  // this.skewX = skewY;
  // --- 5. Final Snap Position Tracking ---
  this.liveActivePosition = this.indexToPosition(nearestIndex);

  // --- 6. State Update for Next Frame (CRITICAL) ---
  this.previousNearestIndex = nearestIndex; 
  
  // Continue the animation loop
  this.animationFrame = requestAnimationFrame(() => this.animate());
}





  /** Start drag */
  startDrag(event: MouseEvent | TouchEvent) {
    // console.log(this.canSlide, "slide can?")
    if (!this.canSlide || this.currentPosition === this.offPosition) return; // cannot drag if off
    event.preventDefault();
    this.dragging = true;
    this.lastX = this.getClientX(event);
  }

  /** Drag */
  onDrag(event: MouseEvent | TouchEvent) {
    if (!this.canSlide || !this.dragging) return;
    event.preventDefault();
    const clientX = this.getClientX(event);
    const deltaX = clientX - this.lastX;
    this.lastX = clientX;

    this.targetLeft = Math.max(0, Math.min(this.targetLeft + deltaX, this.containerWidth - this.handleWidth));
  }

  /** Stop drag */
  stopDrag() {
    if (!this.canSlide || !this.dragging) return;
    this.dragging = false;
    this.snapToNearest();
  }

  /** Click-to-snap anywhere */
  jumpToPosition(event: MouseEvent) {
      if (!this.canSlide) return; // 🚫 locked

    if ((event.target as HTMLElement).closest('.slider-handle')){

      return ;
    } 

    const rect = this.container.nativeElement.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    this.targetLeft = Math.max(0, Math.min(clickX - this.handleWidth / 2, this.containerWidth - this.handleWidth));

    this.snapToNearest();
  }

  /** Snap to nearest position */
  private snapToNearest() {
    if (this.targetPosition === this.offPosition) {
      this.handle.nativeElement.style.opacity = '0';
      this.handle.nativeElement.style.pointerEvents = 'none';
      this.previousPosition = this.currentPosition;
      this.currentPosition = this.offPosition;
      this.positionChange.emit({ current: this.currentPosition, previous: this.previousPosition });
      return;
    }

    // Coming from off → normal
    if (this.currentPosition === this.offPosition) {
      this.handle.nativeElement.style.opacity = '1';
      this.handle.nativeElement.style.pointerEvents = 'auto';
    }

    // Find nearest snap
    const normalized = this.targetLeft / (this.containerWidth - this.handleWidth);
    let closestIndex = 0;
    let minDist = Math.abs(this.snapPositions[0] - normalized);
    for (let i = 1; i < this.snapPositions.length; i++) {
      const d = Math.abs(this.snapPositions[i] - normalized);
      if (d < minDist) {
        minDist = d;
        closestIndex = i;
      }
    }

    const snappedPosition = this.indexToPosition(closestIndex);

    this.targetLeft = this.snapPositions[closestIndex] * (this.containerWidth - this.handleWidth);

    if (this.currentPosition !== snappedPosition) {
      this.previousPosition = this.currentPosition;
      this.currentPosition = snappedPosition;
      this.positionChange.emit({ current: this.currentPosition, previous: this.previousPosition });
    } 
         
     
      // this.positionChange.emit({ current: this.currentPosition, previous: this.previousPosition });
    
    
  }

  /** External setter for position */
  setPosition(pos: SlidePosition | number) {
      if (!this.canSlide) return; // 🚫 locked

    this.targetPosition = pos;

    if (pos === this.offPosition) {
      this.handle.nativeElement.style.opacity = '0';
      this.handle.nativeElement.style.pointerEvents = 'none';
      this.previousPosition = this.currentPosition;
      this.currentPosition = this.offPosition;
      this.positionChange.emit({ current: this.currentPosition, previous: this.previousPosition });
    } else {
      // Coming from off
      if (this.currentPosition === this.offPosition) {
        this.handle.nativeElement.style.opacity = '1';
        this.handle.nativeElement.style.pointerEvents = 'auto';
      }
      this.targetLeft = this.snapPositions[this.positionToIndex(pos as SlidePosition)] * (this.containerWidth - this.handleWidth);
      this.snapToNearest();
    }
  }

  /** Utility: get X coordinate */
  private getClientX(event: MouseEvent | TouchEvent): number {
    return event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
  }

  private positionToIndex(pos: SlidePosition): number {
    return pos === '/calendar' ? 0 : pos === '/menu' ? 1 : pos === '/accounts' ? 3 : 2;
  }

  private indexToPosition(index: number): SlidePosition {
    return index === 0 ? '/calendar' : index === 1 ? '/menu' : index === 3 ? '/accounts' : this.showOrders ? '/order' : '/notifications';
  }
}
